import Image from 'next/image'
import white from '../../../public/images/nav/mobile/triangle.png'
import black from '../../../public/images/nav/mobile/triangle-black.png'

const Triangle = ({type = null}) => {
    const width = 12
    const height = 5 
    const attributes = { 
        width, 
        height, 
        src: type === 'black' ? black : white, 
        alt: 'jts-triangle',
    } 
    return <>
        <Image {...attributes}/>
    </>
}

export default Triangle